"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const keccak_1 = __importDefault(require("keccak"));
const buffer_1 = require("../buffer");
function sha3(...args) {
    return keccak_1.default('keccak256')
        .update(Buffer.concat(args.map(arg => buffer_1.anyToBuffer(arg))))
        .digest();
}
exports.sha3 = sha3;
//# sourceMappingURL=utils.js.map